/* @flow */

import {useMutation} from '@apollo/react-hooks';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    FeedbackSubmit as FeedbackSubmitMutation,
    FeedbackSubmitVariables,
    FeedbackSubmitInput,
} from 'nutshell-graphql-types';

import FEEDBACK_SUBMIT from '../mutations/feedback-submit.graphql';

export const useFeedbackSubmit = (): ({
    feedbackSubmit: (FeedbackSubmitInput) => Promise<*>,
    isLoading: boolean,
    error: ?string,
}) => {
    const [feedbackSubmit, {loading, error}] = useMutation<
        FeedbackSubmitMutation,
        FeedbackSubmitVariables,
    >(FEEDBACK_SUBMIT);

    return {
        feedbackSubmit: (input: FeedbackSubmitInput) => feedbackSubmit({variables: {input}}),
        isLoading: loading,
        error: safelyGetGraphQLErrorMessage(error),
    };
};
